<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="3">
                <CInput
                  label="Name"
                  invalid-feedback="Name should be filled"
                  required
                  v-model="$v.deliveryForm.name.$model"
                  :is-valid="!$v.deliveryForm.name.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <CInput
                  label="Alias"
                  invalid-feedback="Alias should be filled"
                  required
                  v-model="$v.deliveryForm.alias.$model"
                  :is-valid="!$v.deliveryForm.alias.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label for="status">Delivery Status</label>
                  <model-select
                    class="form-control"
                    :options="deliveryStatusList"
                    v-model="$v.deliveryForm.status.$model"
                    :isError="$v.deliveryForm.status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.deliveryForm.status.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Delivery Status should be filled.
                  </div>
                </div>
              </CCol>

              <CCol sm="3">
              <CSelect
                label="Using Resi"
                invalid-feedback="Please select One"
                :options="resiOptions"
                required
                placeholder="Please Select one"
                :value.sync="$v.deliveryForm.using_resi.$model"
                :is-valid="!$v.deliveryForm.using_resi.$invalid"
              />
            </CCol>
            </CRow>
            
            <CRow>
              <CCol sm="6">
                <CTextarea
                  rows="4"
                  label="Description"
                  invalid-feedback="Description should be filled"
                  required
                  v-model="$v.deliveryForm.description.$model"
                  :is-valid="!$v.deliveryForm.description.$invalid"
                />
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              :disabled="$v.deliveryForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab>
            <template slot="title"> Delivery Type </template>
            <br />
            <GlobalTable
              title="Delivery Type"
              :fields="fields"
              :items="items"
              :editButton="true"
              :redirectDetail="false"
              :isLoading="isLoading"
              :withCard="false"
              @addForm="addForm"
              @editForm="editForm"
            ></GlobalTable>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">{{ form_type }} Form Delivery Type</h6>
      </template>

      <CForm>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Name"
              invalid-feedback="Name should be filled"
              required
              v-model="$v.deliveryTypeForm.name.$model"
              :is-valid="!$v.deliveryTypeForm.name.$invalid"
            />
          </CCol>
          <CCol sm="3">
            <CInput
              label="Price"
              type="number"
              invalid-feedback="Price should be filled"
              required
              v-model="$v.deliveryTypeForm.price.$model"
              :is-valid="!$v.deliveryTypeForm.price.$invalid"
            />
          </CCol>
          <CCol sm="3">
            <CInput
              label="Time Estimation"
              invalid-feedback="Time Estimation should be filled"
              required
              v-model="$v.deliveryTypeForm.time_estimation.$model"
              :is-valid="!$v.deliveryTypeForm.time_estimation.$invalid"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol lg="3">
            <div class="form-group">
              <label for="province">Province</label>
              <model-select
                class="form-control"
                id="province"
                :options="provinceList"
                v-model="$v.deliveryTypeForm.province.$model"
                :isError="$v.deliveryTypeForm.province.$invalid"
                @input="filterRegency"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.deliveryTypeForm.province.$invalid"
                class="invalid-feedback-custom"
              >
                Province should be filled.
              </div>
            </div>
          </CCol>
          <CCol lg="3">
            <div class="form-group">
              <label for="regency">Regency</label>
              <model-select
                class="form-control"
                id="regency"
                :options="regenciesList"
                v-model="$v.deliveryTypeForm.regencies.$model"
                :isError="$v.deliveryTypeForm.regencies.$invalid"
                @input="filterDistrict"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.deliveryTypeForm.regencies.$invalid"
                class="invalid-feedback-custom"
              >
                Please select one
              </div>
            </div>
          </CCol>

          <CCol lg="3">
            <div class="form-group">
              <label for="district">District</label>
              <model-select
                class="form-control"
                id="district"
                :options="districtList"
                v-model="$v.deliveryTypeForm.district.$model"
                :isError="$v.deliveryTypeForm.district.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.deliveryTypeForm.district.$invalid"
                class="invalid-feedback-custom"
              >
                Please select one
              </div>
            </div>
          </CCol>

          <CCol sm="3">
            <div class="form-group">
              <label for="status">Delivery Type Status</label>
              <model-select
                class="form-control"
                id="status"
                :options="deliveryTypeStatusList"
                v-model="$v.deliveryTypeForm.status.$model"
                :isError="$v.deliveryTypeForm.status.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.deliveryTypeForm.status.$invalid"
                class="invalid-feedback-custom"
              >
                Delivery Type Status should be filled.
              </div>
            </div>
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.deliveryTypeForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../templates/Loading";
import { required } from "vuelidate/lib/validators";

export default {
  name: "DeliveryDetail",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Delivery Detail",
      form_type:"",
      productList: [],
      issueList: [],
      userList: [],
      provinceList: [],
      regenciesList: [],
      districtList: [],
      items: [],
      deliveryForm: tableInterfaces.delivery,
      deliveryTypeForm: tableInterfaces.delivery_type,
      isLoading: false,
      activeTab: 0,
      fields: [
        { key: "name", label: "Name", sorter: true },
        { key: "province_name", label: "Coverage Province", sorter: true },
        { key: "regencies_name", label: "Coverage Regencies", sorter: true },
        { key: "district_name", label: "Coverage District", sorter: true },
        { key: "price", label: "Price", sorter: true },
        { key: "time_estimation", label: "Time Estimation", sorter: true },
        { key: "delivery_type_status", label: "Status", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      resiOptions: [
        { value: "1", label: "Yes" },
        { value: null, label: "No" },
      ],
      addButton: false,
      isEdit: false,
      deliveryStatusList: [],
      deliveryTypeStatusList: [],
    };
  },
  validations: {
    deliveryForm: {
      name: { required },
      alias: { required },
      description: { required },
      using_resi: { },
      status: { required },
    },
    deliveryTypeForm: {
      delivery: {},
      name: { required },
      price: { required },
      time_estimation: { required },
      status: { required },
      province: { required },
      regencies: { required },
      district: {required},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDetailDelivery(id);
      this.getDeliveryType(id);
      this.getDeliveryStatusList();
      this.getDeliveryTypeStatusList();
    },
    back: function () {
      this.$router.go(-1);
    },
    getDetailDelivery: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/master/delivery/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.deliveryForm = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDeliveryType: function (id) {
      this.axios
        .get("console/master/delivery_type/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            // console.log(response.data.data)

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/master/delivery/update", this.deliveryForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Delivery",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Delivery");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    addForm: function () {
      this.form_type = "Add"
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.axios
      .get("/console/dropdown/regency/" + item.province)
      .then((response) => {
        this.regenciesList = response.data.data;
      });

      this.axios
      .get("/console/dropdown/district/" + item.regencies)
      .then((response) => {
        this.districtList = response.data.data;
      });

      this.addForm();
      this.form_type = "Edit"
      this.isEdit = true;
      this.deliveryTypeForm = item;
      this.deliveryTypeForm.id = item.id;
    },
    resetForm: function () {
      for (var i in tableInterfaces.delivery_type) {
        tableInterfaces.delivery_type[i] = null;
      }
      this.deliveryTypeForm = tableInterfaces.delivery_type;
    },
    submitForm: function (event) {
      event.preventDefault();
      let route = this.$route.path.split("/");
      this.deliveryTypeForm.delivery = route[4];
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/delivery_type/edit", this.deliveryTypeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.addButton = false;
              this.init(route[4]);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/delivery_type/add", this.deliveryTypeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.addButton = false;
              this.init(route[4]);
            });
        }
      }
    },
    getDeliveryTypeStatusList: function () {
      this.axios.get("/console/master/delivery_type/options").then((response) => {
        this.deliveryTypeStatusList = response.data.delivery_type_status;
        this.provinceList = response.data.province;
      });
    },
    getDeliveryStatusList: function () {
      this.axios
        .get("/console/master/delivery_status/listing-for-dropdown")
        .then((response) => {
          this.deliveryStatusList = response.data.data;
        });
    },
    filterRegency: function () {
      this.deliveryTypeForm.regencies = null;
      this.deliveryTypeForm.district = null;
      this.regenciesList = [];
      this.districtList = [];
      this.axios
        .get("/console/dropdown/regency/" + this.deliveryTypeForm.province)
        .then((response) => {
          this.regenciesList = response.data.data;
        });
    },
    filterDistrict: function () {
      this.deliveryTypeForm.district = null;
      this.districtList = [];
      this.axios
        .get("/console/dropdown/district/" + this.deliveryTypeForm.regencies)
        .then((response) => {
          this.districtList = response.data.data;
        });
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>
